/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vivid_Olive_Pike_HikeInputs */

const en_vivid_olive_pike_hike = /** @type {(inputs: Vivid_Olive_Pike_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The user and all connected settings will be deleted from the organization`)
};

const de_vivid_olive_pike_hike = /** @type {(inputs: Vivid_Olive_Pike_HikeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer wird damit aus dieser Organisation entfernt.`)
};

/**
* | output |
* | --- |
* | "The user and all connected settings will be deleted from the organization" |
*
* @param {Vivid_Olive_Pike_HikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const vivid_olive_pike_hike = /** @type {((inputs?: Vivid_Olive_Pike_HikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vivid_Olive_Pike_HikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vivid_olive_pike_hike(inputs)
	return de_vivid_olive_pike_hike(inputs)
});